import * as moment from 'moment';
import { CollaboratorMarksRecomendedWrapperResponse } from '../interfaces/marks-recommended.interface';

export interface RecommendedMarkPair {
  inicio: string;
  fin: string;
}

export function buildRecommendedMarkPairs(data: CollaboratorMarksRecomendedWrapperResponse): RecommendedMarkPair[] {
  const ordenadas = [...data.marks].sort(
    (a, b) => new Date(a.dtime ?? 0).getTime() - new Date(b.dtime ?? 0).getTime()
  );
  const pares: RecommendedMarkPair[] = [];
  for (let i = 0; i < ordenadas.length; i += 2) {
    const inicio = ordenadas[i];
    const fin = ordenadas[i + 1];
    if (inicio && fin && inicio.dtime && fin.dtime) {
      pares.push({
        inicio: moment(inicio.dtime).format('HH:mm'),
        fin: moment(fin.dtime).format('HH:mm'),
      });
    }
  }
  return pares;
}
